import { render } from "./AuthenticatedDashboard.vue?vue&type=template&id=0798ddcd"
import script from "./AuthenticatedDashboard.vue?vue&type=script&lang=js"
export * from "./AuthenticatedDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__